export default __webpack_public_path__ + "static/media/science.ada10f41.svg";